import {
    CUSTOMER_METHODS_PLACE_BETS,
    CUSTOMER_METHODS_SWITCH_EVENTS,
    CUSTOMER_METHODS_SWITCH_ALL_EVENTS,
    BWG_METHODS_SWITCH_COMPETITOR,
    CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA,
    CUSTOMER_METHODS_PHASE_CHANGE,
    CUSTOMER_METHODS_SEEK_EVENTS,
    CUSTOMER_METHODS_SET_HEIGHT,
    CUSTOMER_METHODS_OPEN_COMPETITOR_STATS,
    CUSTOMER_METHODS_OPEN_EVENT_STATS,
    CUSTOMER_METHODS_GET_COMPETITOR_IMAGE,
    CUSTOM_INTERNAL_DATA,
    REQUEST_CURRENT_DATA
 } from './actionTypes'

export const placeBets = (data: any) => ({
    type: CUSTOMER_METHODS_PLACE_BETS,
    data
})

export const switchEvents = (data: any) => ({
    type: CUSTOMER_METHODS_SWITCH_EVENTS,
    data
})

export const switchCompetitor = (data: any) => {
    return ({
        type: BWG_METHODS_SWITCH_COMPETITOR,
        data
    })
}

export const sendCurrentPhaseData = (data: any) => {
    return ({
        type: CUSTOMER_METHODS_SEND_CURRENT_PHASE_DATA,
        data
    })
}

export const switchAllEvents = (data: any) => ({
    type: CUSTOMER_METHODS_SWITCH_ALL_EVENTS,
    data
})

export const phaseChange = (data: any) => ({
    type: CUSTOMER_METHODS_PHASE_CHANGE,
    data
})

export const seekEvents = (data: any) => ({
    type: CUSTOMER_METHODS_SEEK_EVENTS,
    data
})

export const setHeight = (data: any) => {
    return ({
        type: CUSTOMER_METHODS_SET_HEIGHT,
        data
    })
}
export const openCompetitorStats = (data: any) => ({
    type: CUSTOMER_METHODS_OPEN_COMPETITOR_STATS,
    data
})

export const openEventStats = (data: any) => ({
    type: CUSTOMER_METHODS_OPEN_EVENT_STATS,
    data
})

export const getCompetitorImage = (data: any) => ({
    type: CUSTOMER_METHODS_GET_COMPETITOR_IMAGE,
    data
})

export const customInternalData = (data: any) => {
    return ({
        type: CUSTOM_INTERNAL_DATA,
        data
    })
}
